import { Icon } from '@toggle/design-system';
import { CatalystInsight, CatalystInsightType } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getCatalystInsightIconProps } from '~/widgets/catalyst-insights-drawer/catalyst-insight-icon/utils';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './ClickableCatalystInsightTooltip.styles';

interface ClickableCatalystInsightTooltipProps {
  insights: CatalystInsight[];
  category: CatalystInsightType;
}

export const ClickableCatalystInsightTooltip = ({
  insights,
  category,
}: ClickableCatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();

  const iconProps = getCatalystInsightIconProps({ isBordered: true });
  const isCompanyCatalyst = category === 'company';
  return (
    <>
      {insights.map(insight => (
        <S.TooltipWrapper
          key={insight.id}
          onClick={() =>
            // TODO refactor hardcoded value once we introduce the market catalysts
            openDrawer({
              type: 'company',
              entityTag: insight.identifier,
              insightId: insight.id,
            })
          }
        >
          <Icon {...iconProps} size={32} />
          <S.RightWrapper>
            <S.TooltipTitleLabel>
              {isCompanyCatalyst
                ? t('insights:catalyst.titleCompanyCatalyst')
                : t('insights:catalyst.titleMarketCatalyst')}
            </S.TooltipTitleLabel>
            <S.CategoryLabel>
              {/* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */}
              {t(`catalyst.subcategories.${insight.sub_category}`)}
            </S.CategoryLabel>
          </S.RightWrapper>
        </S.TooltipWrapper>
      ))}
    </>
  );
};
